import { useClientReference } from '@shared/hooks/useClientReference';
import { useCallback } from 'react';

export const useThingToDo = () => {
  const { clientReference } = useClientReference();
  const constructCampaignUrl = useCallback(
    (url: string | undefined) => {
      if (!url) {
        return '';
      }
      try {
        const campaignUrl = new URL(url);
        campaignUrl.searchParams.set('campaign', clientReference);
        return campaignUrl.href;
      } catch {
        return url;
      }
    },
    [clientReference],
  );

  return { constructCampaignUrl };
};
